module.exports = __webpack_public_path__ + "img/doorbell-circle.e872e1eb.png";